module.exports = "https://p.cds.unp.clasificados.pe/logo-gec-dark-grey.5e5443533a36f1a9e5a96ec10c82e9dc.svg";